import { StatusReportTemplateKey } from "@forgepoint/shared";

/** Display title and description per status-report template. */
export const TEMPLATE_DISPLAY: Record<
  StatusReportTemplateKey,
  { title: string; description: string }
> = {
  [StatusReportTemplateKey.STANDARD]: {
    title: "Standard: Your Tasks",
    description:
      "Every user's default: their open tasks, longest-waiting first.",
  },
  [StatusReportTemplateKey.SALES_REP]: {
    title: "Sales Rep: My Deals",
    description:
      "Customers to follow up with and where the rep's in-flight quotes are stuck.",
  },
  [StatusReportTemplateKey.ESTIMATOR]: {
    title: "Estimator: My Queue",
    description:
      "What to estimate today, in order, and what each item is waiting on.",
  },
  [StatusReportTemplateKey.MANAGER]: {
    title: "Manager: Deal Acceleration",
    description:
      "Pipeline health, stuck deals, aging team tasks, and admin call-outs.",
  },
};

/** The four template keys in report display order. */
export const TEMPLATE_ORDER: StatusReportTemplateKey[] = [
  StatusReportTemplateKey.STANDARD,
  StatusReportTemplateKey.SALES_REP,
  StatusReportTemplateKey.ESTIMATOR,
  StatusReportTemplateKey.MANAGER,
];
